import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Organization } from 'src/app/shared/models/organization.model';
import { SharedService } from 'src/app/shared/shared.service';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { environment } from 'src/environments/environment';
import { PushNotificationService, Message, PushNotification } from './push-notification.service';

@Component({
    selector: 'app-push-notification',
    templateUrl: './push-notification.component.html',
    styleUrls: ['./push-notification.component.css'],
    standalone: false
})
export class PushNotificationComponent implements OnInit {

  public currentOrganizationId: number;
  public message: Message = new Message();
  public menu = 'org';
  public errorMsg: string;
  public pastNotifications: PushNotification[] = [];

  public imageBaseUrl = environment.dynamicImageUrl;
  public fileSizeError = false;
  public imagePath: any;

  private _organization: Organization;
  private _imageToUpload: File = null;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router,
    private _pushNotificationService: PushNotificationService, private _toastService: ToastService,
    private _sharedService: SharedService) {
      this._toastService.remove();
    }

  ngOnInit(): void {
    const urlPramas = this._activatedRoute.snapshot.params;
    if (parseInt(localStorage.getItem('orgId'), 10) === 5 || parseInt(localStorage.getItem('orgId'), 10) === 6 ||
      parseInt(localStorage.getItem('orgId'), 10) === 7) {
      this.menu = 'vss';
    } else {
      this.menu = (this._activatedRoute.snapshot.url[0].path === 'user' ? 'user' : 'org');
    }
    if (!urlPramas.orgId) {
      this._router.navigate(['/']);
    }
    this.currentOrganizationId = urlPramas.orgId;
    this._pushNotificationService.getPushNotification(this.currentOrganizationId.toString()).subscribe(result => {
      console.log(result);
      this.pastNotifications = result;
    });
  }

  handleImageFileInput(event: any) {
    const files = event.target.files;
    this.fileSizeError = false;
    if (files.length === 0) { return; }
    if (files.length > 1) { return; }
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // return this._toastr.warning(this._translate.instant('event.advertiseEvent.imageError'));
      return;
    }
    if (files[0].size > 9500000) {
      this.fileSizeError = true;
      return;
    }
    const reader = new FileReader();
    this._imageToUpload = files.item(0);
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagePath = reader.result;
    };
  }

  onSubmitPushNotification() {
    this.errorMsg = undefined;
    if (!this.message.it || !this.message.de || !this.message.en) {
      console.error('Please insert a message');
    } else {
      this._pushNotificationService.submitPushNotification(this.currentOrganizationId.toString(),
        JSON.stringify(this.message), this._imageToUpload).subscribe(result => {
          this.imagePath = null;
          this._imageToUpload = null;
          this.message = new Message();
          this._toastService.show('', {
            classname: 'bg-success text-light',
            delay: 2000,
            autohide: true,
          });
        }, error => {
          switch (error) {
            case 610:
              this.errorMsg = 'limitError';
              break;
            case 611:
              this.errorMsg = 'sameSendError';
              break;
            default:
              console.error(error);
              break;
          }
        });
    }
  }

  deleteImage() {
    alert('Unable to delete image');
  }

}
